/**
 * The readable half of a Clerk error.
 *
 * Clerk returns `{ errors: [{ longMessage, message }] }`, and what a member
 * should see is the long one. Shared by every surface that talks to Clerk
 * directly: the account page and the registration form's email card.
 */
export function describeClerkError(err: unknown): string {
  const e = err as {
    errors?: { longMessage?: string; message?: string }[];
    message?: string;
  };
  return (
    e?.errors?.[0]?.longMessage ??
    e?.errors?.[0]?.message ??
    e?.message ??
    "Something went wrong"
  );
}
